import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

const TOAST_DURATION = 3000;

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef();

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
    setVisible(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      timeoutRef.current = null;
    }, TOAST_DURATION);
  }, []);

  const value = {
    show: showToast,
    success: (msg) => showToast(msg, 'success'),
    error: (msg) => showToast(msg, 'error'),
    info: (msg) => showToast(msg, 'info'),
    warning: (msg) => showToast(msg, 'warning'),
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className={`custom-toast-container${visible ? ' show' : ''}`}
        aria-live="polite" aria-atomic="true">
        {toast && (
          <div className={`custom-toast custom-toast-${toast.type}`}>{toast.message}</div>
        )}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastProvider; 